/* NOTE: Adding styles to the row behaves very differently
 *       between browsers. You probably want to apply styles
 *       to the cells instead.
 */
import React, { useRef } from 'react';

const StripedTableRow = ({
    id = 'striped-table-row',
    index,
    evenStyle,
    oddStyle,
    ...props
}) => {
    const rowRef = useRef(null);

    return (
        <tr
            {...props}
            id={id}
            ref={rowRef}
            style={{
                boxSizing: 'border-box',
                ...props.style,
                ...(index % 2
                    ? {
                          ...evenStyle
                      }
                    : {
                          ...oddStyle
                      })
            }}
        />
    );
};

export default StripedTableRow;
